import { render, staticRenderFns } from "./BaseConfirmIcon.vue?vue&type=template&id=5fb6af3c&scoped=true"
import script from "./BaseConfirmIcon.vue?vue&type=script&lang=js"
export * from "./BaseConfirmIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirmIcon.vue?vue&type=style&index=0&id=5fb6af3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6af3c",
  null
  
)

/* custom blocks */
import block0 from "./BaseConfirmIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports